<template>
  <div class="overlay-wrapper">
    <div class="row services">
      <div
        v-if="nextStep && loyaltyProgramMapNextStep.status"
        :class="itemClasses"
      >
        <div class="service shadow-hover">
          <img
            src="../../img/privilege-program/up.png"
            alt="up"
          >
          <div class="body">
            <p class="title">
              Эффективное увеличение тарифа
            </p>
            <p
              v-for="(condition, index) of loyaltyProgramMapNextStepConditions"
              :key="index"
              class="description conditions"
              v-html="condition"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isServiceNotConnected($getConst('SERVICE_SERM'))"
        :class="itemClasses"
      >
        <div class="service shadow-hover">
          <img
            src="../../img/privilege-program/serm.jpg"
            alt="up"
          >
          <div class="body">
            <p class="title">
              Управление репутацией (SERM)
            </p>
            <p class="description">
              Мониторинг негативных, положительных и нейтральных отзывов о Заказчике в поисковой выдаче.
            </p>
            <button
              class="btn background-white border-danger text-danger"
              :disabled="isOrderBtnDisabled($getConst('SERVICE_SERM'))"
              @click="order($getConst('SERVICE_SERM'))"
            >
              <c-spinner v-if="isServiceOrdering($getConst('SERVICE_SERM'))" /> Заказать
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isServiceNotConnected($getConst('SERVICE_SMM'))"
        :class="itemClasses"
      >
        <div class="service shadow-hover">
          <img
            src="../../img/privilege-program/smm.png"
            alt="up"
          >
          <div class="body">
            <p class="title">
              Продвижение в социальных сетях
            </p>
            <p class="description">
              Увеличим Ваши продажи за счет интерактивного взаимодействия с клиентами в социальных сетях.
            </p>
            <button
              class="btn background-white border-danger text-danger"
              :disabled="isOrderBtnDisabled($getConst('SERVICE_SMM'))"
              @click="order($getConst('SERVICE_SMM'))"
            >
              <c-spinner v-if="isServiceOrdering($getConst('SERVICE_SMM'))" /> Заказать
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="isServiceNotConnected($getConst('SERVICE_TECH_SUPPORT'))"
        :class="itemClasses"
      >
        <div class="service shadow-hover">
          <img
            src="../../img/privilege-program/technical-support.png"
            alt="up"
          >
          <div class="body">
            <p class="title">
              Техническая поддержка сайта
            </p>
            <p class="description">
              Комплекс работ, обеспечивающий реализацию любых задач и решение любых проблем, связанных с работой сайта.
            </p>
            <button
              class="btn background-white border-danger text-danger"
              :disabled="isOrderBtnDisabled($getConst('SERVICE_TECH_SUPPORT'))"
              @click="order($getConst('SERVICE_TECH_SUPPORT'))"
            >
              <c-spinner v-if="isServiceOrdering($getConst('SERVICE_TECH_SUPPORT'))" /> Заказать
            </button>
          </div>
        </div>
      </div>
    </div>
    <c-loading-overlay v-if="fetching" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import modal from '../mixins/modal'
import CSpinner from '../components/ui/CSpinner'
import CLoadingOverlay from './ui/CLoadingOverlay'

/**
 * Список неподключенных услуг.
 */
export default {
  name: 'ServicesNotConnected',
  components: { CLoadingOverlay, CSpinner },
  mixins: [modal],
  props: {
    /**
     * Показывать ли блок увеличения тарифа
     */
    nextStep: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      itemClasses: ['col-xs-12', 'col-sm-6', 'col-lg-3']
    }
  },
  computed: {
    loyaltyProgramMapNextStepConditions () {
      return this.loyaltyProgramMapNextStep.conditions.split('[|]')
    },
    ...mapState({
      clientInfo: state => state.seo.client.info.client,
      loyaltyProgramMapNextStep: state => state.seo.forms.loyaltyProgramMap.nextStep,
      domainSelected: state => state.seo.client.domains.selected,
      phone: state => state.seo.forms.serviceOrder.phone,
      fetching: state => state.seo.forms.loyaltyProgramMap.fetching
    }),
    ...mapGetters({
      isServiceNotConnected: 'seo/forms/loyaltyProgramMap/isServiceNotConnected',
      isServiceOrdering: 'seo/forms/serviceOrder/isOrdering',
      isServiceOrdered: 'seo/forms/serviceOrder/isOrdered'
    })
  },
  mounted () {
    if (this.domainSelected) {
      this.loyaltyProgramMapFetch()
    }
    this.$root.$on('clientDomainsSelectedChange', this.loyaltyProgramMapFetch)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.loyaltyProgramMapFetch)
  },
  methods: {
    /**
     * Загружает данные программы привилегий.
     */
    loyaltyProgramMapFetch () {
      this.formsLoyaltyProgramMapFetch(this.domainSelected)
    },
    /**
     * Доступен ли заказ указанной услуги.
     *
     * @param {String} service
     * @returns {boolean}
     */
    isOrderBtnDisabled (service) {
      return !this.domainSelected || this.isServiceOrdering(service) || this.isServiceOrdered(service)
    },
    /**
     * Подготавливает данные формы и показывает модальное окно заказа услуги с формой.
     *
     * @param service
     */
    order (service) {
      this.setService(service)
      if (!this.phone && this.clientInfo.phone) {
        this.setPhone(this.clientInfo.phone)
      }
      this.showModal(this.$getConst('SERVICE_ORDER_MODAL_ID'))
    },
    ...mapMutations({
      setService: 'seo/forms/serviceOrder/setService',
      setPhone: 'seo/forms/serviceOrder/setPhone'
    }),
    ...mapActions({
      formsLoyaltyProgramMapFetch: 'seo/forms/loyaltyProgramMap/fetch'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";
.services {
  display: flex;
  flex-wrap: wrap;

  > div {
    padding: 15px;
  }

  .service {
    height: 100%;
    background-color: white;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    &,
    img {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    img {
      width: 100%;
    }

    .body {
      padding: 30px;

      .title {
        font-size: 1.2em;
        font-weight: bold;
      }

      button {
        width: 100%;
      }
    }
  }
}

</style>

<style lang="scss">
@import "./resources/css/_variables.scss";

.services .service .body .description.conditions span {
  color: $textSuccessColor;
}
</style>
